import { jsx as _jsx } from "react/jsx-runtime";
import { useHostContext } from 'src/core/hooks/useHostContext';
import { ManageModule } from 'src/modules/modules/components/manageModule';
export function Module() {
    const { createModuleConceptToggle } = useHostContext();
    if (!createModuleConceptToggle)
        return null;
    return _jsx(ManageModule, {});
}
